import apiClient from "../core/HttpClient";
import ShoppingCompany from "../models/ShoppingCompany";

export function shoppingCompanyLogoUrl(logo?: string | null) {
  if (!logo) return undefined;
  if (logo.startsWith("http://") || logo.startsWith("https://")) return logo;
  const api = process.env.REACT_APP_API_URL ?? "";
  const origin = api.replace(/\/api\/?$/, "");
  return `${origin}/${logo.replace(/^\//, "")}`;
}

export default class ShoppingCompanyService {
  url = "/ShoppingCompanies";

  public async getShoppingCompanies(shoppingCategoryId?: number | null): Promise<ShoppingCompany[]> {
    return apiClient
      .get(this.url, {
        params: shoppingCategoryId ? { shoppingCategoryId } : undefined,
      })
      .then((res) => res.data);
  }

  public async getShoppingCompanyById(id: number | string): Promise<ShoppingCompany> {
    return apiClient.get(`${this.url}/${id}`).then((res) => res.data);
  }

  public async createShoppingCompany(model: ShoppingCompany) {
    return apiClient.post(this.url, {
      name: model.name,
      logo: model.logo ?? null,
      url: model.url ?? null,
      discountCode: model.discountCode,
      shoppingCategoryId: model.shoppingCategoryId,
    });
  }

  public async updateShoppingCompany(model: ShoppingCompany) {
    return apiClient.put(`${this.url}/${model.id}`, {
      id: model.id,
      name: model.name,
      logo: model.logo ?? null,
      url: model.url ?? null,
      discountCode: model.discountCode,
      shoppingCategoryId: model.shoppingCategoryId,
    });
  }

  public async deleteShoppingCompany(id: number | string) {
    return apiClient.delete(`${this.url}/${id}`);
  }

  public async uploadLogo(id: number | string, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post(`${this.url}/${id}/logo`, formData);
  }
}
